import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, BookOpenIcon, FileTextIcon, FolderIcon, MicIcon, ClockIcon } from 'lucide-react';
export function BundleContents() {
  const items = [{
    icon: BookOpenIcon,
    title: 'La Guía Exprés 2026',
    description: 'El núcleo de tu preparación con las preguntas de civismo actualizadas.'
  }, {
    icon: FileTextIcon,
    title: 'Simulador de la Forma N-400',
    description: 'La traducción y explicación de las "preguntas trampa" de moralidad.'
  }, {
    icon: FolderIcon,
    title: 'Checklist de la Carpeta Maestra',
    description: 'Qué documentos llevar (originales y copias) para que el oficial vea que eres una persona organizada.'
  }, {
    icon: MicIcon,
    title: 'Guía de Pronunciación Escrita',
    description: 'Para que digas las respuestas correctamente aunque no hables inglés fluido.'
  }, {
    icon: ClockIcon,
    title: 'Plan de Acción de 24 Horas',
    description: 'Qué hacer, qué vestir y cómo calmar los nervios el día antes.'
  }];
  return <section className="w-full bg-white" data-id="element-28">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-30">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mb-12 text-center" data-id="element-31">
            ¿Qué Incluye Tu Bundle?
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-32">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-[#F7F5F0] p-6 rounded-lg border-l-4 border-[#C9A84C]" data-id="element-33">
                <div className="flex items-start gap-4" data-id="element-34">
                  <div className="bg-[#1B2A4A] p-3 rounded-lg" data-id="element-35">
                    <item.icon className="w-6 h-6 text-[#C9A84C]" data-id="element-36" />
                  </div>
                  <div className="flex-1" data-id="element-37">
                    <h3 className="font-bold text-lg text-[#1B2A4A] mb-2" data-id="element-38">
                      {item.title}
                    </h3>
                    <p className="text-gray-700" data-id="element-39">{item.description}</p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}